/**
 * TOSS Web Application — the top bar's vertical rule
 *
 * Separates the clocks from the controls (owner's variant B, 26.08.2026): time is something the
 * bar states, the icons are things you press, and without the rule the three time zones read as
 * a fourth control.
 *
 * Hidden below 768 exactly where `TimeZoneClock` is, so the rule never appears with nothing on
 * its left.
 */

export function TopBarDivider(): JSX.Element {
  return (
    <span
      aria-hidden="true"
      className="hidden lg:block w-px h-5 flex-shrink-0 bg-[var(--color-border)]"
    />
  );
}

export default TopBarDivider;
